import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { Router } from '@angular/router';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-add-edit-positioning',
    templateUrl: './add-edit-positioning.component.html',
    styleUrls: ['./add-edit-positioning.component.scss'],
    standalone: false
})
export class AddEditPositioningComponent implements OnInit {
  type: any;
  addPositioningForm: FormGroup;
  id: number;
  positioning: any;
  invalidFiles: boolean;
  fileIconOn: boolean;
  filesList: FileList = null;
  allFiles: any[];
  productId: any;
  competitorId: any;
  user: User;

  constructor(public dialogRef: MatDialogRef<AddEditPositioningComponent>,
              private dataService: DataService,
              public utils: UtilsService,
              private authService: AuthService,
              private router: Router,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.type = data.type;
                this.id = data.id;
                this.user = this.authService.getUserData();
                this.fileIconOn = true;
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.competitorId = router.routerState.snapshot.root.children[0].children[0].params.competitorId;
                this.allFiles = new Array<any>();
                if (this.type === 'Edit') {
                  this.getPositioning();
                }
              }

  ngOnInit(): void {
    this.addPositioningForm = new FormGroup({
      CompetitorChallenge: new FormControl(this.positioning ?  this.positioning.competitorChallenge : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      ProductOffer: new FormControl(this.positioning ?  this.positioning.productOffer : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      ProductValue: new FormControl(this.positioning ?  this.positioning.productValue : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      link: new FormControl(this.positioning ?  this.positioning.path : null, [Validators.required, Validators.pattern(this.utils.urlReg)]),
      file: new FormControl({ value: this.positioning ?  this.positioning.fileName : null, disabled: true }),
    });
  }

  getPositioning() {
    this.positioning = this.data.positioning;
  }

  toggleIcon(type: string) {
    if (type === 'link' && this.fileIconOn) {
      this.invalidFiles = false;
      this.addPositioningForm.get('link').setValue(null);
      this.fileIconOn = !this.fileIconOn;
    } else if (type === 'file' && !this.fileIconOn) {
      this.filesList = null;
      this.fileIconOn = !this.fileIconOn;
      this.addPositioningForm.get('file').setValue('');
    }
  }

  closeDialog() {
    if (this.type === 'Edit') {
      if (this.allFiles.length ===  0) {
        if (this.positioning.supportMaterial.length ===  0) {

        } else {
          if (this.addPositioningForm.dirty && this.type === 'Add') {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Warning',
                type: 'Warn',
                message: 'You will miss your information once you close',
                buttonText: 'cancel',
                numberOfButtons: 2,
                seconButtonText: 'Ok'
              }
            });
            dialogRef.afterClosed().subscribe((status) => {
              if (status === 'Ok') {
                this.dialog.closeAll();
              }
            });
          } else {
            this.dialog.closeAll();
          }
        }
      } else {
          if (this.positioning.supportMaterial.length ===  0) {

          } else {
            if (this.addPositioningForm.dirty && this.type === 'Add') {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Warning',
                  type: 'Warn',
                  message: 'You will miss your information once you close',
                  buttonText: 'cancel',
                  numberOfButtons: 2,
                  seconButtonText: 'Ok'
                }
              });
              dialogRef.afterClosed().subscribe((status) => {
                if (status === 'Ok') {
                  this.dialog.closeAll();
                }
              });
            } else {
              this.dialog.closeAll();
            }
          }
      }
    } else {
      if (this.addPositioningForm.dirty && this.type === 'Add') {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Warning',
            type: 'Warn',
            message: 'You will miss your information once you close',
            buttonText: 'cancel',
            numberOfButtons: 2,
            seconButtonText: 'Ok'
          }
        });
        dialogRef.afterClosed().subscribe((status) => {
          if (status === 'Ok') {
            this.dialog.closeAll();
          }
        });
      } else {
        this.dialog.closeAll();
      }
    }
  }

  deletePositioningMaterial(materialId: any, index: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'supportMaterial',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('CompetitorSupportMaterial/DeleteCompetitorSupportMaterial/'
          + this.productId + '/' + materialId).then((data) => {
            if (data.statusCode === 200) {
              this.positioning.supportMaterial.splice(index, 1);
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  closeDialogRef: true,
                  message: 'Material deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  forceDownload(blob, filename) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = blob;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  downloadResource(url, filename) {
    if (!filename) {
      filename = url.split('\\').pop().split('/').pop();
    }
    fetch(url, {
        headers: new Headers({
          Origin: location.origin
        }),
        mode: 'no-cors'
      })
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        this.forceDownload(blobUrl, filename);
      })
      .catch(e => {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      });
  }

  downloadMyFile(url: any, fileName: string) {
    if (url) {
      this.downloadResource(url , fileName);
    }
  }

  addFileOrListToList() {
    if (this.fileIconOn) {
      if (this.filesList && this.filesList.length > 0) {
        this.allFiles.push({type: 4, file: this.filesList[0]});
      } else {
        this.invalidFiles = true;
        return;
      }
    } else {
      if (this.addPositioningForm.controls.link.valid) {
        this.allFiles.push({type: 2, file:  this.addPositioningForm.get('link').value});
      } else {
        this.addPositioningForm.controls.link.markAsTouched();
        return;
      }
    }
    this.addPositioningForm.get('link').setValue(null);
    this.filesList = null;
    this.addPositioningForm.get('file').setValue('');
    this.toggleIcon('file');
  }

  truncate(string: string) {
    if (string.length  > 32) {
      string = string.slice(0, 32) + '...';
    }
    return string;
  }

  deleteFromFileList(index: any) {
    this.allFiles.splice(index, 1);
  }

  previewImage(fileList: any) {
    this.filesList = fileList;
    if (fileList.length > 0) {
      this.invalidFiles = false;
    }
    let name = '';
    for (let index = 0; index < fileList.length; index++) {
      if (index === 0) {
        name = fileList[index].name;
      } else {
        name = name + ',' + fileList[index].name;
      }
    }
    this.addPositioningForm.get('file').setValue(name);
  }

  onSubmit() {
    this.addFileOrListToList();
    if (this.fileIconOn) {
      this.addPositioningForm.get('link').setValue('https://link.link');
    }
    if (this.addPositioningForm.valid) {
      if (this.type === 'Edit') {
        const payload = {
          CompetitorPositioningId: this.positioning.id,
          ProductId: parseInt(this.productId.toString(), 10),
          ProductOffer: this.addPositioningForm.get('ProductOffer').value,
          productValue: this.addPositioningForm.get('ProductValue').value,
          CompetitorChallenges: this.addPositioningForm.get('CompetitorChallenge').value,
          CompetitorId: parseInt(this.competitorId.toString(), 10)

        };
        this.utils.showProgressDialog();
        this.dataService.put('product/CompetitorPositioning/UpdateCompetitorPositioning', payload, true).then((data) => {
          if (data.statusCode === 200) {
            if (this.allFiles.length > 0) {
              this.updateMaterial(payload, this.positioning.id);
            } else {
              this.dialogRef.close(payload);
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Competitor positioning updated successfully',
                  buttonText: 'Ok'
                }
              });
            }
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      } else if (this.type === 'Add') {
        const payload = {
          ProductId: parseInt(this.productId.toString(), 10),
          ProductOffer: this.addPositioningForm.get('ProductOffer').value,
          productValue: this.addPositioningForm.get('ProductValue').value,
          CompetitorChallenges: this.addPositioningForm.get('CompetitorChallenge').value,
          ProductCompetitorId: parseInt(this.competitorId.toString(), 10)
        };
        this.utils.showProgressDialog();
        this.dataService.post('product/CompetitorPositioning/CreateCompetitorPositioning', payload, true).then((data) => {
          if (data.statusCode === 200) {
            this.updateMaterial(payload, data.data.id);
          }
        });
        this.utils.closeProgressDialog();
      }
    } else {
      this.addPositioningForm.markAllAsTouched();
    }
  }
  updateMaterial(payload: any, valuesId: any) {
    for (let index = 0; index < this.allFiles.length; index++) {
      const element = this.allFiles[index];
      const filePayload = new FormData();
      filePayload.append('file', element.type === this.utils.supportMaterials.File ? element.file : null);
      filePayload.append('link', element.type === this.utils.supportMaterials.Link ? element.file : null);
      filePayload.append('productId', this.productId.toString());
      filePayload.append('competitorPositioingId', valuesId);
      filePayload.append('type', element.type);
      filePayload.append('name', "Support 7");
      filePayload.append('description', "Support 7 Description");

      this.dataService.put('CompetitorSupportMaterial/UpdateCompetitorSupportMaterialFile', filePayload, true).then((mediaData) => {
        if (mediaData.statusCode === 200) {
          this.dialogRef.close(payload);
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    }

    if (this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Success',
          type: 'Success',
          message: 'Competitor positioining added successfully',
          buttonText: 'Ok'
        }
      });
    } else {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Success',
          type: 'Success',
          message: 'Competitor positioning updated successfully',
          buttonText: 'Ok'
        }
      });
    }
  }

}
